import * as lodash from 'lodash';

import {
  CreateSignalOptions,
  Signal,
  WritableSignal,
  signal,
} from '@angular/core';
import { SignalGetter } from '@angular/core/primitives/signals';

export type PatchableSignal<T extends object | unknown | undefined> =
  Signal<T> &
    WritableSignal<T> & {
      /** Updates properties on an object */
      patch(value: Partial<T>): void;
    };

export function patchableSignal<T extends object | unknown | undefined>(
  initialValue: T,
  options?: CreateSignalOptions<T>
): PatchableSignal<T> {
  const internal = signal<T>(initialValue, options) as SignalGetter<T> &
    WritableSignal<T>;

  return Object.assign(internal, {
    patch: (value: Partial<T>) =>
      internal.update(x => lodash.merge(lodash.clone(x), value)),
  });
}
